import { connect } from 'react-redux'
import config from '../../../config.json'
import WrapperPageSimple from '../../WrapperPage/present/WrapperPageSimple'
import Translation from '../../Translation/cont/Translation'

const PageProviderAccess = ({saveState, status, apps}) => {
    return (
        <WrapperPageSimple
            pageTitle={[<Translation id={config.routes.providerPage.transId} />]}>
                
            <iframe key={'provider'} className="provider-system-iframe" src="https://kino-demo.softline.at/embedded/statistics?auth=planetmutlu-demo"/>
        </WrapperPageSimple>
    )
}

export default PageProviderAccess